import axios from 'axios';
import apiService from '../apiService';

export default async function getFileUrl(
  token = '',
  bucket = '',
  key = '',
  expiration = '',
) {
  const options = {
    url: `${apiService.getUrl().externalBase}public/api/files`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    data: {
      Bucket: bucket,
      Key: key,
      Expiration: expiration
    }
  };
  const _ret = await axios(options);
  return _ret.data.Data;
}
